// extracted by mini-css-extract-plugin
export var label = "_d2-1";
export var reminder = "_d2-0";